import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {ScaleAndTranslate} from 'common/src/components/CLCardsMap/CardsMapContainer/CardsMapContainer.types';
import {Comment, CommentUI} from 'common/src/components/Comments/Comments.types';
import {MentionedUser} from 'common/src/modules/users/users.types';
import {campaignCommentsInitialState} from './campaignComments.config';

const campaignCommentsSlice = createSlice({
  name: 'campaignCommentsSlice',
  initialState: campaignCommentsInitialState,
  reducers: {
    resetCommentsState: () => campaignCommentsInitialState,
    updateSelectedCommentNumber: (state, action: PayloadAction<number>) => {
      state.selectedCommentNumber = action.payload;
    },
    updateActiveUsers: (state, action: PayloadAction<MentionedUser[]>) => {
      state.activeUsers = action.payload;
    },
    updateCommentNodeId: (state, action: PayloadAction<number>) => {
      state.commentNodeId = action.payload;
    },
    updateComments: (state, action: PayloadAction<Comment[]>) => {
      state.comments = action.payload;
    },
    updateFilteredComments: (state, action: PayloadAction<CommentUI[]>) => {
      state.filteredComments = action.payload;
    },
    updatePrevScaleAndTranslate: (state, action: PayloadAction<ScaleAndTranslate>) => {
      state.prevScaleTranslate = action.payload;
    },
    updateInAddCommentsState: (state, action: PayloadAction<boolean>) => {
      state.inAddCommentState = action.payload;
    },
  },
});

const {
  resetCommentsState,
  updateSelectedCommentNumber,
  updateActiveUsers,
  updateCommentNodeId,
  updateComments,
  updateFilteredComments,
  updatePrevScaleAndTranslate,
  updateInAddCommentsState,
} = campaignCommentsSlice.actions;
export {
  resetCommentsState,
  updateSelectedCommentNumber,
  updateActiveUsers,
  updateCommentNodeId,
  updateComments,
  updateFilteredComments,
  updatePrevScaleAndTranslate,
  updateInAddCommentsState,
};

export default campaignCommentsSlice.reducer;
